import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { LocationsPage, stockLocationsQueryOptions } from '@/features/inventory';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/locations')({
  staticData: { crumb: 'common:nav.locations', tours: ['settings.locations'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'inventory.read');
  },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...stockLocationsQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: LocationsPage,
});
